import { toast } from 'react-toastify';
import { MAX_IMAGE_SIZE, MAX_VIDEO_SIZE } from '../../../../utils/constants';

export const validateAndFilterFiles = (
  files: File[],
  hasVideo: boolean,
  selectedFiles: File[]
): { validFiles: File[]; newHasVideo: boolean } => {
  // First validate file types
  const validFiles = files.filter((file) => {
    const isValid = file.type.startsWith('image/') || file.type.startsWith('video/');
    if (!isValid) {
      toast.warning(`File "${file.name}" is not a valid image or video file.`);
    }
    return isValid;
  });

  // Check file sizes before proceeding
  const validSizedFiles = validFiles.filter((file) => {
    if (file.type.startsWith('video/')) {
      if (file.size > MAX_VIDEO_SIZE) {
        toast.warning(`Video file "${file.name}" exceeds the maximum size limit of 150MB.`);
        return false;
      }
      return true;
    }

    if (file.type.startsWith('image/')) {
      if (file.size > MAX_IMAGE_SIZE) {
        toast.warning(`Image file "${file.name}" exceeds the maximum size limit of 5MB.`);
        return false;
      }
      return true;
    }
    return false;
  });

  if (validSizedFiles.length === 0) {
    return { validFiles: [], newHasVideo: hasVideo };
  }

  // Check for video files in new selection
  const newVideoFiles = validSizedFiles.filter((file) => file.type.startsWith('video/'));
  const newImageFiles = validSizedFiles.filter((file) => file.type.startsWith('image/'));

  // If trying to mix video and images
  if (hasVideo && newImageFiles.length > 0) {
    toast.warning(`Can't upload images and videos in one submission. Please select only one type of file.`);
    return { validFiles: [], newHasVideo: hasVideo };
  }

  if (selectedFiles.some((file) => file.type.startsWith('image/')) && newVideoFiles.length > 0) {
    toast.warning(`Can't upload images and videos in one submission. Please select only one type of file.`);
    return { validFiles: [], newHasVideo: hasVideo };
  }

  // Handle video file selection
  if (newVideoFiles.length > 1) {
    toast.warning('Only one video file is allowed per submission');
    return { validFiles: [], newHasVideo: hasVideo };
  }

  // If adding a video, replace any existing video
  if (newVideoFiles.length === 1) {
    return { validFiles: [newVideoFiles[0]], newHasVideo: true };
  }

  return { validFiles: newImageFiles, newHasVideo: hasVideo };
};
